import * as types from "./types";
import JigsawAPI from "../../services/jigsaw";
import * as selectors from "./selectors";

import { normalize, schema } from "../normalize";

export const ancillarySummarySchema = new schema.Array(
  new schema.Entity("ancillaries", {}, { idAttribute: "isbn" })
);

export const defaultEntities = {
  ancillaries: {}
};

export const fetchAncillarySummaryRequest = () => ({
  type: types.FETCH_ANCILLARY_SUMMARY_REQUEST
});

export const fetchAncillarySummarySuccess = data => ({
  type: types.FETCH_ANCILLARY_SUMMARY_SUCCESS,
  data
});

export const fetchAncillarySummaryFailure = error => ({
  type: types.FETCH_ANCILLARY_SUMMARY_FAILURE,
  error
});

export const fetchAncillarySummary = (force = false) => async (
  dispatch,
  getState
) => {
  const state = getState();
  if (force || selectors.shouldFetchAncillarySummary(state)) {
    dispatch(fetchAncillarySummaryRequest());
    return JigsawAPI.getAncillariesSummary()
      .then(({ ancillaries }) => {
        dispatch(
          fetchAncillarySummarySuccess(
            normalize(ancillaries, ancillarySummarySchema, defaultEntities)
          )
        );
      })
      .catch(error => dispatch(fetchAncillarySummaryFailure(error)));
  }
};

export const fetchAllAccessCodesRequest = () => ({
  type: types.FETCH_ALL_ACCESS_CODE_REQUEST
});

export const fetchAllAccessCodesSuccess = data => ({
  type: types.FETCH_ALL_ACCESS_CODE_SUCCESS,
  data
});

export const fetchAllAccessCodesFailure = error => ({
  type: types.FETCH_ALL_ACCESS_CODE_FAILURE,
  error
});

export const fetchAllAccessCodes = (force = false) => async (
  dispatch,
  getState
) => {
  const state = getState();
  if (force || selectors.shouldFetchAllAccessCodes(state)) {
    dispatch(fetchAllAccessCodesRequest());
    JigsawAPI.getAllAccessCodes()
      .then(data => {
        dispatch(fetchAllAccessCodesSuccess(data));
        return data;
      })
      .catch(error => dispatch(fetchAllAccessCodesFailure(error)));
  }
};

export const redeemAncillaryRequest = isbn => ({
  type: types.REDEEM_ANCILLARY_REQUEST,
  isbn
});

export const redeemAncillarySuccess = (data, isbn) => ({
  type: types.REDEEM_ANCILLARY_SUCCESS,
  data,
  isbn
});

export const redeemAncillaryFailure = (isbn, error) => ({
  type: types.REDEEM_ANCILLARY_FAILURE,
  isbn,
  error
});

export const redeemAncillary = isbn => async (dispatch, getState) => {
  const state = getState();
  if (selectors.shouldRedeemAncillary(state)) {
    dispatch(redeemAncillaryRequest(isbn));
    JigsawAPI.redeemAncillary(isbn)
      .then(data => {
        dispatch(redeemAncillarySuccess(data, isbn));
        return data;
      })
      .catch(error => dispatch(redeemAncillaryFailure(isbn, error)));
  }
};

export const fetchAncillariesRequest = isbn => ({
  type: types.FETCH_ANCILLARIES_REQUEST,
  isbn
});

export const fetchAncillariesSuccess = (isbn, data) => ({
  type: types.FETCH_ANCILLARIES_SUCCESS,
  isbn,
  data
});

export const fetchAncillariesFailure = (isbn, error) => ({
  type: types.FETCH_ANCILLARIES_FAILURE,
  isbn,
  error
});

export const fetchAncillaries = isbn => async (dispatch, getState) => {
  const state = getState();
  if (selectors.shouldFetchAncillaries(state, isbn)) {
    dispatch(fetchAncillariesRequest(isbn));
    return JigsawAPI.getAncillariesForVbid(isbn)
      .then(data => {
        dispatch(fetchAncillariesSuccess(isbn, data));
      })
      .catch(error => dispatch(fetchAncillariesFailure(isbn, error)));
  }
};
